<div class="page-wrapper">
    <div class="mid-component-section" *ngIf="!forgotPassword">
        <div class="logo">
            <img src="assets/images/icpc-logo.png" width="100px" alt="logo">
        </div>

       <div class="mid-heading-top">
            Welcome to  Directorate of Intelligence
        </div>



        <form class="form-wrapper" [formGroup]="loginForm">
            <div>
                <mat-form-field floatLabel="never" style="width: 100%; font-size: 14px;" appearance="outline">
                    <input type="email" matInput placeholder="Email" autocomplete="email" formControlName="email">
                </mat-form-field>
            </div>

            <div>
                <mat-form-field floatLabel="never" style="width: 100%; font-size: 14px;" appearance="outline">
                    <input type="password" matInput placeholder="Password" autocomplete="current-password" formControlName="password">
                </mat-form-field>
            </div>

            <div class="error-style" *ngIf="errorMsg">{{errorMsg}}</div>

            <button mat-flat-button color="red" [disabled] = "loginForm.invalid || loading" class="signIn-button" (click)="signIn()">
                <p class="button_text" *ngIf = "!(loading)" > SIGN IN </p>

                <img class = "button_loader" src="assets/images/Infinity-1.8s-200px.svg" alt="" *ngIf="loading">
            </button>
            <div *ngIf="errorLogin" class="error-style">
                <span>{{errorDisplay}}</span>
            </div>


            <div style="margin-top: 30px; text-align: center; font-size: 12px;">
                Forgot Password? Click <a style="color: #ce0101; cursor: pointer;"(click)="openForgetPassword()"
                class="click">here</a> to reset
            </div>
        </form>

        <div class="bottom">
            <div></div>
            <div class="flex-el">
                Powered by <a target="_blank" href="https://comsoftltd.com/">
                <img src="assets/images/comsoftlogo.png" alt="comsoftlogo" style="width: 100px;">
            </a>
            </div>
        </div>
    </div>

    <div class="mid-component-section custom-scroll-bar" *ngIf="forgotPassword && !linksent">
        <div class="logo">
            <img src="assets/images/icpc-logo.png" width="75px" alt="efccPNG">
        </div>

        <div class="mid-heading-bottom">
             Directorate of Intelligence
        </div>

        <div style="font-size: 12px;" class="mid-heading-bottom">
            Enter your registered Email Address to receive your reset link.
        </div>

        <div class="form-wrapper">
            <!-- <div class="mid-heading-low" style="text-align: left;">
                Enter your Email Address here:
            </div> -->
            <div>
                <mat-form-field floatLabel="never" style="width: 100%; font-size: 14px;" appearance="outline">
                    <input type="email" matInput placeholder="Email" [(ngModel)]="emailSent">
                </mat-form-field>
            </div>

            <div class="error-style" *ngIf="resetError">{{errormsg}}</div>

            <button mat-flat-button color="red" [disabled]="emailSent == '' || codeloading" class="signIn-button" (click)="resetPassword()">
                <p class="button_text" *ngIf = "!codeloading" > Send Link </p>

                <img class = "button_loader" src="assets/images/Infinity-1.8s-200px.svg" alt="" *ngIf="codeloading">
            </button>

            <a (click)="openForgetPassword()" style="margin-top: 20px; justify-content: center; cursor: pointer;" class="flex-el"><mat-icon>keyboard_backspace</mat-icon> &nbsp; Back to Login </a>
        </div>

        <div class="bottom">
            <div></div>
            <div class="flex-el">
                Powered by <a target="_blank" href="https://comsoftltd.com/">
                <img src="assets/images/comsoftlogo.png" alt="comsoftlogo" style="width: 100px;">
            </a>
            </div>
        </div>
    </div>

    <div class="mid-component-section" *ngIf="linksent">
        <div class="logo">
            <img src="assets/images/icpc-logo.png" width="75px" alt="logo">
        </div>

        <div class="mid-heading-bottom">
             Directorate of Intelligence
        </div>

        <div class="form-wrapper">
            <div class="mid-heading-low">
                A reset password link has been sent to <b>{{emailSent}},</b> <br> Check your email to complete the process.
            </div>
            &nbsp;
            &nbsp;
            <button mat-flat-button color="red" class="signIn-button" (click)="backToLogin()">
                <p class="button_text" *ngIf = "!resetloading" > Back to Login </p>
                <img class = "button_loader" src="assets/images/Infinity-1.8s-200px.svg" alt="" *ngIf="resetloading">
            </button>


            <div style="margin-top: 30px; text-align: center; font-size: 12px;">
                <img class = "button_loader" src="assets/images/Infinity-1.8s-200px.svg" alt="" *ngIf="codeloading">
                <a class="reset-hover" style="cursor: pointer; font-size: 14px;" *ngIf="!codeloading" (click)="resetPassword()">Resend Link</a>
            </div>
        </div>

        <div class="bottom">
            <div></div>
            <div class="flex-el">
                Powered by <a target="_blank" href="https://comsoftltd.com/">
                <img src="assets/images/comsoftlogo.png" alt="comsoftlogo" style="width: 100px;">
            </a>
            </div>
        </div>
    </div>

    <div class="footer">&copy; 2021. All Rights Reserved. Independent Corrupt Practices Commission(ICPC).</div>
</div>



